import { Component } from "@builder.io/sdk";

export const productDescriptionConfig: Component = {
  name: "Product Description",
  inputs: [
    {
      name: "id",
      type: "string",
      defaultValue: "about",
      helperText:
        "Unique identifier for the section. Useful for linking to the section by '#id'.",
      required: true,
      advanced: true,
    },
    {
      name: "color",
      type: "string",
      enum: ["light-orange", "white"],
      defaultValue: "light-orange",
      helperText: "Background color for the section",
    },
    {
      name: "title",
      friendlyName: "Heading",
      type: "string",
      defaultValue: "About Services For Families",
      helperText: "Main heading for the section",
      required: true,
    },
    {
      name: "description",
      friendlyName: "Description",
      type: "richText",
      required: true,
      defaultValue: `
        <div>
          <p>
            Our wide range of services ensures that whether you are seeking long-term care, private duty medical care, specialized care, or assistance for specific diseases, your loved ones receive the highest quality of care. Our dedicated team of caregivers, nurses, and therapists are committed to enhancing the quality of life for both clients and their families by delivering personalized care in the comfort and familiarity of their own homes.
          </p>
          <p>
            By choosing Care Indeed, families can rest assured knowing their loved ones are in capable hands. Our comprehensive services address physical, emotional, and social well-being, promoting independence, safety, and overall health. With a focus on individualized care plans, we support families through every stage of their health journey, providing peace of mind and allowing families to focus on creating cherished memories together.
          </p>
        </div>
      `,
      helperText: "Description text for the section",
    },
    {
      name: "additionalData",
      type: "list",
      helperText: "Additional data for the section",
      subFields: [
        {
          name: "title",
          type: "string",
          friendlyName: "Heading",
        },
        {
          name: "description",
          type: "richText",
          friendlyName: "Description",
        },
      ],
    },

    {
      name: "descriptionClassName",
      type: "string",
      defaultValue: "flex flex-col gap-2",
      helperText: "CSS classes for the description container",
      hideFromUI: true,
    },
    {
      name: "paragraphClassName",
      type: "string",
      helperText: "CSS classes for individual paragraphs",
      hideFromUI: true,
    },
  ],
};
